// src/theme/overrides/MuiDataGrid.ts
import { Theme, alpha } from '@mui/material/styles';

const MuiDataGrid = {
    styleOverrides: {
        root: ({ theme }: { theme: Theme }) => ({
            '& .MuiDataGrid-columnHeaders': {
                fontSize: theme.typography.body1.fontSize,
                fontWeight: 500,
            },
            // Also need to override the inner container for proper header background
            '& .MuiDataGrid-columnHeader': {
                backgroundColor: '#E3E3E3',
            },
            '& .MuiDataGrid-cell': {
                fontSize: theme.typography.body1.fontSize,
            },
        }),
    },
};

export default MuiDataGrid;